import React from "react"
//import styled from 'styled-components'
import tw, { styled } from "twin.macro"
//import breakpoint from 'styled-components-breakpoint'

import LogoSVG from "./logo.inline.svg"

const Brand = ({ linkElement, ...props }) => {
  const Elem = linkElement

  return (
    <Style className="brand">
      <Elem className="brand__link" aria-label="Go Home" {...props}>
        {props.svg ? props.svg : <LogoSVG />}
      </Elem>
    </Style>
  )
}
export default Brand

const Style = styled.div`
  > a {
    ${tw`
            block 
            overflow-hidden 
            text-primary
            maxWidth[calc(110px + 3vmin)]
            xl:maxWidth[155px]
            hover:text[var(--nova-primary-dark)]
        `}
    color: var(--nova-primary);

    &:focus-visible {
      outline: none;
      color: var(--nova-orange);
    }

    @media (hover: hover) {
      &:hover,
      &:active {
        opacity: 0.9;

        path {
          ${tw`fill[currentColor]!`}
        }
      }
    }

    svg {
      object-fit: cover;
      ${tw`align-top w-full h-full`}

      path {
        transition: fill 0.1s ease;
      }

      path + path {
        fill: #fcd480;
      }

      footer & path {
        fill: var(--nova-default);
      }
    }
  }
`
